import { FeatureFlag, getVariant } from '@monolith/legacy/services/features';

/** Treatment variant of the PRICE-2 experiment: the simplified tile (PRICE-2 + PRICE-3 discount label). */
export const TILE_SIMPLIFIED_VARIANT = 'simplified';

/**
 * Whether the current user is in the simplified-tile treatment of the `PRICE-2`
 * A/B experiment ({@link FeatureFlag.TileSimplification}).
 *
 * This is an experiment, not a kill-switch: only the `simplified` variant sees the
 * simplified tile (PRICE-2 content removal + PRICE-3 discount label). Everything
 * else — the `control` variant, `off`, `ineligible`, logged-out and dev (flag
 * absent) — falls back to the legacy tile. Exposure is tracked automatically:
 * because the flag carries an `experiment` key, its variant is attached to every
 * analytics event as `__experiments`, so no explicit tracking is needed here.
 */
export const isTileSimplified = (): boolean => getVariant(FeatureFlag.TileSimplification) === TILE_SIMPLIFIED_VARIANT;
